/**
 * Lightweight skeleton shown while lazy-loaded route chunks are loading.
 * Replaces the heavy full-page spinner for a smoother perceived transition.
 */
export function PageSkeleton() {
  return (
    <div className="space-y-4 animate-pulse">
      {/* Page header skeleton */}
      <div className="flex items-start justify-between gap-4">
        <div className="space-y-2">
          <div className="h-7 w-48 rounded-lg bg-muted" />
          <div className="h-4 w-72 rounded bg-muted/60" />
        </div>
        <div className="h-9 w-32 rounded-lg bg-muted" />
      </div>

      {/* KPI cards skeleton */}
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="flex items-center gap-3 rounded-lg border bg-card px-4 py-3">
            <div className="h-9 w-9 shrink-0 rounded-lg bg-muted" />
            <div className="space-y-2 flex-1">
              <div className="h-2.5 w-12 rounded bg-muted/60" />
              <div className="h-4 w-10 rounded bg-muted" />
            </div>
          </div>
        ))}
      </div>

      {/* Table skeleton */}
      <div className="rounded-card border bg-card overflow-hidden">
        <div className="border-b px-4 py-3 flex gap-8">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="h-3 w-16 rounded bg-muted" />
          ))}
        </div>
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="flex gap-8 border-b px-4 py-3.5 last:border-0">
            {Array.from({ length: 6 }).map((_, j) => (
              <div
                key={j}
                className="h-3.5 rounded bg-muted/50"
                style={{ width: `${50 + (((i + j) * 17) % 40)}%`, flex: 1 }}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
